import { Injectable, NgZone } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { fromEvent, Observable, timer } from 'rxjs';
import { filter, switchMap, tap } from 'rxjs/operators';

interface AppVersion {
    version: string;
    build?: string;
    date?: string;
}

@Injectable({
    providedIn: 'root'
})
export class VersionCheckerService {
    private readonly checkIntervalMs = 1 * 60 * 1000;
    private readonly versionUrl = './assets/version.json';

    private currentVersion: string | null = null;
    public versionNotificada = false;

    constructor(
        private readonly http: HttpClient,
        private readonly snackBar: MatSnackBar,
        private readonly zone: NgZone
    ) { }

    initVersionCheck(): void {
        this.obtenerVersionInicial();
    }

    checkPeriodically(): Observable<AppVersion> {
        return timer(this.checkIntervalMs, this.checkIntervalMs).pipe(
            tap(() => console.log('[VersionChecker] Periodically')),
            switchMap(() => this.obtenerVersion())
        )
    }

    checkVisibilityChange(): Observable<AppVersion> {
        return fromEvent(document, 'visibilitychange').pipe(
            filter(() => document.visibilityState === 'visible'),
            tap(() => console.log('[VersionChecker] Visibility change')),
            switchMap(() => this.obtenerVersion())
        );
    }

    checkVersion(): void {
        this.obtenerVersion().subscribe(version => {
            this.validarVersion(version);
        });
    }

    public obtenerVersionInicial(): void {
        this.obtenerVersion().subscribe(version => {
            this.currentVersion = version.version;

            console.log(
                '[VersionChecker] Versión inicial:',
                this.currentVersion
            );
        });
    }

    public obtenerVersion() {
        return this.http.get<AppVersion>(
            `${this.versionUrl}?v=${Date.now()}`
        );
    }

    public validarVersion(version: AppVersion, ejecutaSnackbar: boolean = false, mensaje? : string): void {
        if (
            this.versionNotificada ||
            !this.currentVersion
        ) {
            return;
        }

        if (this.currentVersion !== version.version) {
            console.log(
                '[VersionChecker] Nueva versión detectada:',
                version.version
            );

            this.versionNotificada = true;
            if (ejecutaSnackbar) this.mostrarSnackBarVersionNueva();
        }
    }

    public mostrarSnackBarVersionNueva(mensaje : string = 'Hay una nueva versión de la aplicación disponible.'): void {
        this.zone.run(() => {
            const snackBarRef = this.snackBar.open(
                mensaje,
                'Actualizar',
                {
                    duration: 0,
                    horizontalPosition: 'center',
                    verticalPosition: 'bottom'
                }
            );

            snackBarRef.onAction().subscribe(() => {
                window.location.reload();
            });
        });
    }
}